var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
      ref: "multipleTable",
      staticClass: "clazz_width_100",
      attrs: {
        data: _vm.list,
        "default-sort": { prop: "createTime", order: "descending" },
      },
      on: {
        "sort-change": _vm.sortChange,
        "selection-change": _vm.handleSelectionChange,
      },
    },
    [
      _vm.selectable
        ? _c("yxt-table-column", {
            attrs: {
              "show-overflow-tooltip": false,
              type: "selection",
              width: "38",
              align: "right",
              "clear-padding": "left-right",
            },
          })
        : _vm._e(),
      _vm._l(_vm.columnConfigs, function (item) {
        return _c("yxt-table-column", {
          key: item.prop,
          attrs: {
            label: item.label,
            prop: item.prop,
            "show-overflow-tooltip": item.showTooltip,
            width: item.width,
            "min-width": item.minWidth,
            "clear-padding": item.clearPadding,
            "popover-html": item.popoverHtml,
          },
          scopedSlots: _vm._u(
            [
              _vm.hasSlot("header")
                ? {
                    key: "header",
                    fn: function () {
                      return [_vm._t("header", null, { config: item })]
                    },
                    proxy: true,
                  }
                : null,
              {
                key: "default",
                fn: function (scope) {
                  return item.type != "selection"
                    ? [
                        _vm.hasSlot(item.prop)
                          ? _vm._t(
                              item.prop,
                              function () {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.cellShow(item, scope.row))
                                    ),
                                  ]),
                                ]
                              },
                              { config: item, data: scope.row }
                            )
                          : _c("span", [
                              _vm._v(_vm._s(_vm.cellShow(item, scope.row))),
                            ]),
                      ]
                    : undefined
                },
              },
            ],
            null,
            true
          ),
        })
      }),
      _vm.tableOperation && _vm.tableOperation.length
        ? _c("yxt-table-column", {
            attrs: {
              label: _vm.$t("pc_biz_ote_btn_operate"),
              width: "80",
              fixed: "right",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm._l(_vm.tableOperation, function (item) {
                      return _c(
                        "yxt-button",
                        {
                          key: item.label,
                          attrs: {
                            disabled: _vm.actionDisabled(item.disabled),
                            type: "text",
                          },
                          on: {
                            click: function ($event) {
                              return item.action(scope.row)
                            },
                          },
                        },
                        [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
                      )
                    })
                  },
                },
              ],
              null,
              false,
              2108783886
            ),
          })
        : _vm._e(),
      _vm.tableData.length === 0
        ? _c("yxt-empty", { attrs: { slot: "empty" }, slot: "empty" })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }